import type { SVGProps } from 'react';
import * as React from 'react';

const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/calendar">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.90002 1.40002C7.39708 1.40002 7.80002 1.80297 7.80002 2.30002V3.80002H16.2V2.30002C16.2 1.80297 16.603 1.40002 17.1 1.40002C17.5971 1.40002 18 1.80297 18 2.30002V3.80002H18.3C20.1226 3.80002 21.6 5.27749 21.6 7.10003V17.3C21.6 19.1226 20.1226 20.6 18.3 20.6H5.70003C3.87749 20.6 2.40002 19.1226 2.40002 17.3V7.10003C2.40002 5.27749 3.87748 3.80002 5.70002 3.80002H6.00002V2.30002C6.00002 1.80297 6.40297 1.40002 6.90002 1.40002ZM5.70002 8.00002C4.8716 8.00002 4.20002 8.6716 4.20002 9.50002V17.3C4.20002 18.1285 4.8716 18.8 5.70003 18.8H18.3C19.1285 18.8 19.8 18.1285 19.8 17.3V9.50002C19.8 8.6716 19.1285 8.00002 18.3 8.00002H5.70002Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default CalendarIcon;
